<template>
  <div class="social-media">
    <span class="social-media__heading"> Социальные сети </span>
    <ul class="mt-8">
      <li>
        <a href="https://t.me/minec_russia" title="Официальный телеграм-канал" target="_blank">
          <img src="@/assets/images/svg/social-tg.svg" alt="Телеграмм" />
        </a>
      </li>
      <li>
        <a href="https://vk.com/minec_russia" title="Вконтакте" target="_blank">
          <img src="@/assets/images/svg/social-vk.svg" alt="Вконтакте" />
        </a>
      </li>
      <li>
        <a href="https://ok.ru/minec_russia" title="Мы в одноклассниках" target="_blank">
          <img src="@/assets/images/svg/social-ok.svg" alt="Одноклассники" />
        </a>
      </li>
      <li>
        <!-- http://bit.do/fUtuY- для просмотра статистики переходов -->
        <a href="http://bit.do/fUtuY" title="Мы в Яндекс.Дзен" target="_blank">
          <img src="@/assets/images/svg/social-dz.svg" alt="Яндекс Дзен" />
        </a>
      </li>
      <li>
        <a href="https://rutube.ru/channel/999390/" title="RuTube" target="_blank">
          <img src="@/assets/images/svg/social-yt.svg" alt="RuTube" />
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
  export default {
    name: 'SocialMedia',
  };
</script>

<style scoped>
  .social-media {
    line-height: 100%;
  }

  .social-media__heading {
    font-size: 12px;
    font-weight: 600;
    color: #fff;
  }

  .social-media ul {
    font-size: 0;
    padding: 0;
    list-style: none;
  }

  .social-media li {
    display: inline-block;
    vertical-align: middle;
    margin-right: 1.125rem;
    padding: inherit;
    list-style: inherit;
  }

  .social-media li:last-child {
    margin-right: 0;
  }

  .social-media a {
    width: 22px;
    height: 20px;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
  }

  .social-media a:hover img {
    -webkit-filter: brightness(0) invert(1);
    filter: brightness(0) invert(1);
  }

  .social-media img {
    display: block;
    max-width: 100%;
    max-height: 100%;
  }
</style>
